import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Reusable luxury project card. Consumes the project schema from data/site.js.
// Clicking navigates to the reusable project detail page.
export const ProjectCard = ({ project }) => {
    return (
        <article
            data-testid={`project-${project.id}`}
            className="group flex h-full flex-col overflow-hidden border border-line bg-white transition-all duration-500 hover:-translate-y-1 hover:border-champagne hover:shadow-[0_28px_70px_rgba(43,43,43,0.1)]"
        >
            <Link to={`/projects/${project.id}`} className="relative block aspect-[4/3] overflow-hidden">
                <img
                    src={project.image}
                    alt={`${project.name}, ${project.location}`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                />
                <div className="absolute left-4 top-4 bg-white/90 px-3 py-1 backdrop-blur-sm">
                    <span className="text-[10px] uppercase tracking-[0.18em] text-charcoal">
                        {project.developer}
                    </span>
                </div>
            </Link>

            <div className="flex flex-1 flex-col p-7">
                <Link to={`/projects/${project.id}`}>
                    <h3 className="font-serif text-2xl leading-tight text-charcoal transition-colors duration-300 group-hover:text-orange">
                        {project.name}
                    </h3>
                </Link>
                <p className="mt-2 text-sm text-slatey">{project.location}</p>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-charcoal/75">
                    {project.audienceLine}
                </p>

                <div className="my-6 h-px w-full bg-line" />

                <div className="grid grid-cols-3 gap-3">
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.12em] text-slatey">
                            Config
                        </p>
                        <p className="mt-1 text-sm font-medium text-charcoal">
                            {project.configurations}
                        </p>
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.12em] text-slatey">
                            Possession
                        </p>
                        <p className="mt-1 text-sm font-medium text-charcoal">
                            {project.possession}
                        </p>
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.12em] text-slatey">
                            Starting
                        </p>
                        <p className="mt-1 font-serif text-lg text-orange">
                            {project.startingPrice}
                        </p>
                    </div>
                </div>

                <Link
                    to={`/projects/${project.id}`}
                    data-testid={`project-cta-${project.id}`}
                    className="group/btn mt-8 inline-flex items-center gap-2 self-start text-xs uppercase tracking-[0.15em] text-charcoal"
                >
                    <span className="border-b border-champagne pb-1 transition-colors duration-300 group-hover/btn:border-orange group-hover/btn:text-orange">
                        View Project
                    </span>
                    <ArrowRight
                        size={14}
                        className="text-orange transition-transform duration-300 group-hover/btn:translate-x-1"
                    />
                </Link>
            </div>
        </article>
    );
};
